// extracted by mini-css-extract-plugin
module.exports = {"dashBoard":"dashBoard_dashBoard__3c-W9"};